import getSelectedTableView from './getSelectedTableView';
import MailListViewState from '../store/schema/MailListViewState';
import { getListViewStore } from '../store/Store';
import { TableQueryType } from '../store/schema/TableQuery';

export default function getMailListViewState(): MailListViewState {
    const tableView = getSelectedTableView();

    if (!tableView) {
        return MailListViewState.Loading;
    } else if (
        getListViewStore().shouldShowSearchBox &&
        tableView.tableQuery.type !== TableQueryType.Search
    ) {
        return MailListViewState.Blank;
    } else if (tableView.hasErrorLoadingTable) {
        return MailListViewState.Error;
    } else if (!tableView.isInitialLoadComplete) {
        return MailListViewState.Loading;
    } else if (tableView.itemIds.length === 0) {
        return MailListViewState.Empty;
    }

    return MailListViewState.Loaded;
}
